import { render, staticRenderFns } from "./bankTransfer.vue?vue&type=template&id=27444059&scoped=true&"
import script from "./bankTransfer.vue?vue&type=script&lang=js&"
export * from "./bankTransfer.vue?vue&type=script&lang=js&"
import style0 from "./bankTransfer.vue?vue&type=style&index=0&id=27444059&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27444059",
  null
  
)

export default component.exports